export const actionsPrefix = '[Order Book]';

export const orderBookFeatureKey = 'order-book';
